/**
 * TypeScript twin of `autopersona_core::link_href::LinkHref` (APA-314).
 *
 * Consumed by both `src-sdk` (validates before patching `href` into the DOM
 * on a customer page — defense in depth, since a cached SDK build can be
 * served by an older or misconfigured API; plan.md §2.3: "Validierung
 * doppelt, serverseitig beim Speichern und im SDK vor dem Schreiben") and
 * `src-frontend` (the LinkEditor's live URL validation). The scheme
 * allow-list and the "empty href is a valid placeholder" rule must stay in
 * lockstep with the Rust implementation in `autopersona-core/src/link_href.rs`.
 */
const ALLOWED_SCHEMES = ['https', 'http', 'mailto', 'tel'];
/**
 * Extracts the scheme prefix (text before the first `:`), but only when it's
 * positioned before any `/`, `?` or `#` — i.e. an actual URI scheme, not a
 * relative path that happens to contain a colon later on (e.g. a query
 * string value).
 */
function extractScheme(raw) {
    const colon = raw.indexOf(':');
    if (colon === -1)
        return null;
    const prefix = raw.slice(0, colon);
    if (prefix === '' || /[/?#]/.test(prefix))
        return null;
    return prefix;
}
/**
 * True when `href` is empty (the placeholder "unset" state), a `#`-fragment,
 * a relative path, or uses one of the allowed schemes
 * (`https:`, `http:`, `mailto:`, `tel:`). False for `javascript:`, `vbscript:`,
 * `file:`, `data:`, and any other scheme not on the allow-list.
 */
export function isAllowedHref(href) {
    if (href === '' || href.startsWith('#') || href.startsWith('/')) {
        return true;
    }
    const scheme = extractScheme(href);
    if (scheme === null)
        return true;
    return ALLOWED_SCHEMES.includes(scheme.toLowerCase());
}
/** True only for `http:` hrefs — the one allowed-but-insecure scheme. */
export function isInsecureHref(href) {
    const scheme = extractScheme(href);
    return scheme !== null && scheme.toLowerCase() === 'http';
}
//# sourceMappingURL=linkHref.js.map